<template>
  <QuoteAndDraft />
</template>

<script>
import QuoteAndDraft from "@/components/Ondemand/Bookings/QuoteFlow.vue";

export default {
  components: {
    QuoteAndDraft,
  },
};
</script>

<style></style>
